import { useSelector } from 'react-redux';

import { IPublicUser } from '@sravni/types/lib/auth';

import { getUser } from '../store/selectors/users';

export function useUser(): IPublicUser | null {
  return useSelector(getUser);
}
